import { gql } from "@apollo/client/core";
import Document_User from '../Document/Document_User'

export default gql`
    ${Document_User}
    fragment Contract_Documents on Contract {
        id
        documents {
            ...Document_User
        }
    }
`
